import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareExclamation,
  faChartBar,
  faFileInvoice,
} from "@fortawesome/pro-regular-svg-icons";
import { ROLES } from "./constant";

export interface itemProp {
  id: number;
  title: string;
  path: string;
  access_role: ROLES[];
  icon: any;
  child: itemProp[];
  classname: string;
  urlCommonWord?: string;
}

export const tpisummaryNavbar: itemProp[] = [
  {
    id: 1,
    title: "Inspection Statistics",
    path: "/tpi-inspection-details",
    access_role: [ROLES.PRSES],
    icon: <FontAwesomeIcon icon={faChartBar} />,
    child: [],
    classname: "tpi-inspection-details",
    urlCommonWord: "tpi-inspection-details"
  },
  {
    id: 2,
    title: "Compared Issues",
    path: "/compare-statistics",
    access_role: [ROLES.PRSES],
    icon: <FontAwesomeIcon icon={faSquareExclamation} />,
    child: [],
    classname: "compare-statistics",
    urlCommonWord: "compare-statistics"
  },
  {
    id: 3,
    title: "TPI BOQ Report",
    path: "/project-boq-report",
    access_role: [ROLES.PRSES],
    icon: <FontAwesomeIcon icon={faFileInvoice} />,
    classname: "project-boq-report",
    urlCommonWord: "project-boq-report",
    child: [],
  },
];
